import authorizer from "./Authorizer";
export const loginSideEffect = () => {
  sessionStorage.clear();
  authorizer.makeAuthorizationRequest();
};
export const logInCallbackSideEffect = async () => {
  const authToken = await authorizer.signinCallback();
  return authToken;
};
